// Featured homepage case study — the Prichard Mall idea.
// Seeded via migration; see supabase migration history.
export const FEATURED_IDEA_ID = "a11ce100-0000-4000-8000-0000000c1ded";
export const FEATURED_IDEA_TITLE = "Revitalize Prichard's Mall";
export const FEATURED_LOCATION = "Prichard, AL";